import React, { useState } from "react";
import {
  Fab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import api from "../../components/commonComponents/axiosSetup";
import axios from "axios";
import { createTicket } from "./utility";
import {
  accountEmail,
  accountName,
} from "../customerManagement/utility/authUtils";
import DeleteIcon from "@mui/icons-material/Delete";
const HelpBadge = ({ open, setOpen, onTcketCreated }) => {
  // const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    issueType: "",
    description: "",
    // pageUrl: '',
    screenshot: null,
  });
  const [errors, setErrors] = useState({});

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    if (!loading) {
      setOpen(false);
      setFormData({
        issueType: "",
        description: "",
        screenshot: null,
      });
      setErrors({});
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    // Clear error when field is edited
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  };

  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB in bytes
const FILE_SIZE_ERROR = "File size exceeds 5MB limit";

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if(file){
      if(file.size > MAX_FILE_SIZE){
        toast.error(FILE_SIZE_ERROR);
        e.target.value = null;
        return
      }
    }
    setFormData({
      ...formData,
      screenshot: file,
    });
  };

  const validate = () => {
    const newErrors = {};
    // if (!formData.name.trim()) newErrors.name = 'Name is required';
    // if (!formData.email.trim()) {
    //   newErrors.email = 'Email is required';
    // } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    //   newErrors.email = 'Email is invalid';
    // }
    if (!formData.issueType) newErrors.issueType = "Issue type is required";
    if (!formData.description.trim())
      newErrors.description = "Description is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);
    try {
      let screenshotUrl = "";

      // 1. Upload screenshot if present
      if (formData.screenshot) {
        const imgForm = new FormData();
        imgForm.append("files", formData.screenshot);
        imgForm.append("token", "SOURCING");

        try {
          const res = await axios.post(
            "https://storage.nyggs.com/setmedia/api/save/file",
            imgForm
          );
          // Use the correct path to get the URL
          screenshotUrl = res.data?.data?.fileUrls?.[0] || "";
        } catch (error) {
          console.log("Screenshot upload failed:", error);
          // Optionally show a toast or error
        }
      }

      // 2. Build main payload (with screenshot URL, not file)
      const payload = {
        ...formData,
        name: accountName(),
        email: accountEmail(),
        screenshot: screenshotUrl,
      };

      // 3. Send to your support ticket API
      const response = await createTicket(payload);
      if (response.status === 200 || response.status === 201) {
        toast.success("Support ticket submitted successfully!");
        handleClose();
        if (onTcketCreated) {
          onTcketCreated();
        }
      }
    } catch (error) {
      console.error("Failed to submit support ticket:", error);
      toast.error("Failed to submit support ticket. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const issueTypes = [
    "Technical Issue",
    "Order Issue",
    "Payment Related Issue",
    "Other",
  ];

  const handleDeleteFile = () => {
    setFormData({
      ...formData,
      screenshot: null,
    });
  };

  return (
    <>
      {/* <Fab
  color="primary"
  aria-label="help"
  variant="extended"
  sx={{
    position: "fixed",
    bottom: 24,
    right: 24,
    px: 3,
    borderRadius: "50px",
    fontWeight: "bold",
    textTransform: "none",
    gap: 1,
    boxShadow: "0 6px 14px rgba(0,0,0,0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.08)",
      boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
    },
  }}
  onClick={handleOpen}
>
  <HelpIcon sx={{ fontSize: 22 }} />
  Help
</Fab>   */}

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
          },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: "var(--bg)",
            color: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 2,
          }}
        >
          <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
            Get Help & Support
          </Typography>
          <IconButton
            size="small"
            onClick={handleClose}
            sx={{ color: "white" }}
            disabled={loading}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 3, mt: 2 }}>
          <Box component="form" onSubmit={handleSubmit}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Fill out the form below to submit a support ticket. Our team will
              get back to you as soon as possible.
            </Typography>

            <Box sx={{ mb: 3 }}>
              {/* <TextField
                fullWidth
                label="Your Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                error={!!errors.name}
                helperText={errors.name}
                disabled={loading}
                required
                sx={{ mb: 2 }}
                InputProps={{ sx: { borderRadius: 1 } }}
              />
              
              <TextField
                fullWidth
                label="Email Address"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                error={!!errors.email}
                helperText={errors.email}
                disabled={loading}
                required
                sx={{ mb: 2 }}
                InputProps={{ sx: { borderRadius: 1 } }}
              /> */}

              <FormControl
                fullWidth
                required
                error={!!errors.issueType}
                sx={{ mb: 2 }}
              >
                <InputLabel>Issue Type</InputLabel>
                <Select
                  name="issueType"
                  value={formData.issueType}
                  onChange={handleChange}
                  label="Issue Type"
                  disabled={loading}
                  sx={{ borderRadius: 1 }}
                >
                  {issueTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
                {errors.issueType && (
                  <Typography variant="caption" color="error">
                    {errors.issueType}
                  </Typography>
                )}
              </FormControl>

              <TextField
                fullWidth
                label="Description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                error={!!errors.description}
                helperText={errors.description}
                disabled={loading}
                required
                multiline
                rows={4}
                sx={{ mb: 2 }}
                InputProps={{ sx: { borderRadius: 1 } }}
                placeholder="Please describe your issue in detail..."
              />

              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  Attach Screenshot/ PDF/ Word (Optional)
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ display: "block", mb: 1 }}
                >
                  Maximum file size: 5MB
                </Typography>
                <Button
                  variant="outlined"
                  component="label"
                  disabled={loading}
                  sx={{
                    borderRadius: 1,
                    textTransform: "none",
                  }}
                >
                  Choose File
                  <input
                    type="file"
                    accept="image/*,application/pdf,.doc,.docx"
                    hidden
                    onChange={handleFileChange}
                  />
                </Button>
                {formData.screenshot && (
                  <>
                    <Typography variant="caption" sx={{ ml: 2, mr:2 }}>
                      {formData.screenshot.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Size:{(formData.screenshot.size / (1024 * 1024)).toFixed(2)} MB
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={handleDeleteFile}
                      disabled={loading}
                      sx={{ color: "error.main" }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </>
                )}
              </Box>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 3, bgcolor: "#f8f9fa" }}>
          <Button
            onClick={handleClose}
            disabled={loading}
            sx={{
              mr: 1,
              px: 3,
              borderRadius: 1,
              textTransform: "none",
              color: "var(--bg)",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            sx={{
              px: 3,
              borderRadius: 1,
              textTransform: "none",
              backgroundColor: "var(--bg)",
            }}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit Ticket"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default HelpBadge;
